import { render } from "./BNavLink.vue?vue&type=template&id=3d78106a&ts=true"
import script from "./BNavLink.vue?vue&type=script&lang=ts"
export * from "./BNavLink.vue?vue&type=script&lang=ts"

import "./BNavLink.vue?vue&type=style&index=0&id=3d78106a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__